import React, { useContext, useEffect, useState, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Context } from '../Context/Context';
import { HisabKitabJantri } from '../Api/GetHisabKitab';
import { Flip, toast } from 'react-toastify';
import NumberBetModal from './Numberbetmodal';
import { Helmet } from 'react-helmet';
export default function BetHistory() {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const [isClient, setIsClient] = useState("");
    const [selectedDate, setSelectedDate] = useState("");
    const [betHistoryData, setBetHistoryData] = useState(null);

    const { setLoad, setLoadColor, numberModal, sideBarOpen, sessionDetail } = useContext(Context);

    const todayDate = new Date().toISOString().split('T')[0];
    const totalValues = betHistoryData?.reduce((acc, curr) => {
        acc.hrf_ps += Number(curr.hrf_ps || 0);
        acc.jodi_ps += Number(curr.jodi_ps || 0);
        acc.profit_loss += Number(curr.profit_loss || 0);
        acc.total_kaam += Number(curr.total_kaam || 0);
        acc.lc_comm += Number(curr.lc_comm || 0);
        return acc;
    }, { hrf_ps: 0, jodi_ps: 0, profit_loss: 0, total_kaam: 0, lc_comm: 0 });

    const handleBetHistory = useCallback(async () => {
        if (!isClient && !selectedDate) return;

        setLoad(true);
        setLoadColor("#434343");

        const userInfo = JSON.parse(localStorage.getItem('userinfo'));

        const data = {
            username: userInfo?.username,
            client_name: isClient,
            user_id: userInfo?.userId,
            date: selectedDate || "",
        };

        try {
            const res = await HisabKitabJantri(data);
            if (res && res.data.status) {
                setBetHistoryData(res.data.data?.hisab_kitab);
            } else {
                toast.error(res?.data?.message || "Something went wrong", {
                    position: "top-right",
                    autoClose: 1500,
                    theme: "colored",
                    transition: Flip,
                });
                setBetHistoryData(null); // Clear previous data on error
            }
        } catch (err) {
            console.error("API Error:", err);
            setBetHistoryData(null);
        } finally {
            setLoad(false);
        }
    }, [isClient, selectedDate, setLoad, setLoadColor]);

    useEffect(() => {
        if (
            pathname === "/hisabKitab" &&
            !numberModal &&
            !sideBarOpen &&
            (isClient || selectedDate)
        ) {
            handleBetHistory();
        }
    }, [pathname, numberModal, sideBarOpen, isClient, selectedDate, handleBetHistory]);

    const handleClientChange = (e) => {
        const value = e.target.value === '' ? null : e.target.value;
        setIsClient(value);
    };

    const handleDateChange = (e) => {
        setSelectedDate(e.target.value);
    };

    return (
        <>
            <Helmet>
                {/* Page Title */}
                <title>Hisab Kitab | Automatic Profit & Loss Calculation | Matka Jantri</title>

                {/* SEO Description */}
                <meta
                    name="description"
                    content="Automatic Hisab Kitab page for Matka calculations. Displays client profit and loss updated in real-time when results are updated."
                />

                {/* SEO Directives */}
                <meta name="robots" content="index, follow" />

                {/* Canonical URL */}
                <link rel="canonical" href="https://app.matkajantri.com/hisab-kitab" />

                {/* Favicon and Icons */}
                <link rel="icon" href="/favicon.ico" type="image/x-icon" />
                <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
                <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
                <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />

                {/* Mobile Optimization */}
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />

                {/* Open Graph */}
                <meta property="og:title" content="Hisab Kitab | Automatic Profit & Loss Calculation | MatkaJantri" />
                <meta
                    property="og:description"
                    content="Automatic Hisab Kitab page for Matka calculations. Displays client profit and loss updated in real-time when results are updated."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://app.matkajantri.com" />
                <meta property="og:image" content="https://app.matkajantri.com/Logo.png" />
                <meta name="google-site-verification" content="d6d81656210c6db7" />
            </Helmet>

            <NumberBetModal />
            <div className='depositContainer'>
                <div className="wrapper" style={{ marginTop: "0px" }}>
                    <div className="section">
                        <div className="top_navbar" style={{ height: "60px", zIndex: 1000 }}>
                            <div className="hamburger">
                                <button className='back_btn' onClick={() => navigate("/game")}>
                                    <i className="fa-solid fa-chevron-left"></i>
                                </button>
                            </div>
                            <div className='gameName'>Hisab Kitab</div>
                        </div>
                    </div>
                </div>

                <div className="Tablecontainer betHistorytableCss">
                    <div className='SelectData'>
                        <div className='container-Section'>
                            <div className="select-section" style={{ display: 'flex', gap: '10px', alignItems: 'center', position: 'relative' }}>
                                <select className="select-dropdown" onChange={handleClientChange} value={isClient || ''}>
                                    <option value=''>Select Client</option>
                                    {sessionDetail?.user_clients?.map((client, index) => (
                                        <option key={index} value={client}>{client}</option>
                                    ))}
                                </select>
                                <input
                                    type="date"
                                    max={todayDate}
                                    value={selectedDate}
                                    onChange={handleDateChange}
                                    className="select-dropdown"
                                    style={{ padding: '6px', fontSize: '14px' }}
                                />
                                {!selectedDate && (
                                    <span style={{
                                        position: 'absolute',
                                        left: 'calc(100% + 15px)',
                                        color: '#999',
                                        fontSize: '14px',
                                        pointerEvents: 'none',
                                        top: '50%',
                                        transform: 'translateY(-50%)'
                                    }}>
                                        Select Date
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>

                    <table>
                        <thead>
                            <tr>
                                <th></th>
                                <th>Client Name</th>
                                <th>Game Name</th>
                                <th>HRF PS</th>
                                <th>Jodi PS</th>
                                <th>Name Result</th>
                                <th>Lc Comm</th>

                                <th>Profit / Loss</th>
                                <th>Total Kaam</th>
                            </tr>
                        </thead>
                        {/* <tbody>
                            {betHistoryData && betHistoryData.length > 0 ? (
                                betHistoryData.map((item, index) => (
                                    <tr key={item._id || index}>
                                        <td>{item.client_name}</td>
                                        <td>{item.game_name}</td>
                                        <td>{item.hrf_ps}</td>
                                        <td>{item.jodi_ps}</td>
                                        <td>{item.name_result}</td>
                                        <td style={{ color: item.profit_loss >= 0 ? 'green' : 'red' }}>
                                            {Math.abs(item.profit_loss)}
                                        </td>
                                        <td>{item.total_kaam}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="6" style={{ textAlign: "center" }}>No data found</td>
                                </tr>
                            )}
                        </tbody> */}
                        <tbody>
                            {betHistoryData && betHistoryData.length > 0 ? (
                                <>
                                    {betHistoryData.map((item, index) => (
                                        <tr key={item._id || index}>
                                            <td></td>
                                            <td>{item.client_name}</td>
                                            <td>{item.game_name}</td>
                                            <td>{item.hrf_ps}</td>
                                            <td>{item.jodi_ps}</td>
                                            <td>{item.name_result}</td>
                                            <td>{item.lc_comm}</td>
                                            <td style={{ color: item.profit_loss >= 0 ? 'green' : 'red' }}>
                                                {Math.abs(item.profit_loss)}
                                            </td>
                                            <td>{item.total_kaam}</td>
                                        </tr>
                                    ))}
                                    {/* <tr style={{ fontWeight: 'bold', backgroundColor: '#ff8e8e' }}>
                                        <td>{isClient || '---'}</td>
                                        <td>---</td>
                                        <td>{totalValues.hrf_ps}</td>
                                        <td>{totalValues.jodi_ps}</td>
                                        <td>---</td>
                                        <td style={{ color: totalValues.profit_loss >= 0 ? 'green' : 'red' }}>
                                            {Math.abs(totalValues.profit_loss)}
                                        </td>
                                        <td>{totalValues.total_kaam}</td>
                                    </tr> */}
                                    <tr style={{ fontWeight: 'bold', backgroundColor: '#ff8e8e' }}>
                                        <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '10px', backgroundColor: '#000000', color: 'white' }}>
                                            T<br />
                                            O<br />
                                            T<br />
                                            A<br />
                                            L
                                        </div>
                                        <td>{isClient || '---'}</td>
                                        <td>---</td>
                                        <td>{totalValues.hrf_ps}</td>
                                        <td>{totalValues.jodi_ps}</td>
                                        <td>---</td>
                                        <td>{totalValues.lc_comm}</td>

                                        <td style={{ color: totalValues.profit_loss >= 0 ? 'green' : 'red' }}>
                                            {Math.abs(totalValues.profit_loss)}
                                        </td>
                                        <td>{totalValues.total_kaam}</td>
                                    </tr>
                                </>
                            ) : (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: "center" }}>No data found</td>
                                </tr>
                            )}
                        </tbody>

                    </table>
                </div>
            </div>
        </>
    );
}
